module.exports = __webpack_public_path__ + "img/google_play.1bafd423.png";